import axios from 'axios';
import { useShiftUI } from './shiftUI.js';

export const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  timeout: 20000
});

// Auto-unwrap paginated responses so consumers can use array methods directly.
// Backend returns { items: [...], total, page, pages }. We expose the array as
// response.data while keeping pagination meta accessible as array properties.
//
// ⚠️ المستند ليس صفحة: فاتورة الشراء كائن فيه `items` و`total` أيضاً، وكان
// المُعترض يستبدلها بمصفوفة بنودها فيضيع `_id` (ومنه كانت تُطلب
// /api/purchases/undefined) والمورد وطريقة الدفع. الفاصل: الصفحة بلا `_id`.
// بعض المسارات تُعيد { items } فقط بلا total/page، فلا يصحّ اشتراطهما.
function isPageEnvelope(d) {
  return d
    && typeof d === 'object'
    && !Array.isArray(d)
    && Array.isArray(d.items)
    && !d._id;
}

api.interceptors.response.use(
  (res) => {
    const d = res.data;
    if (isPageEnvelope(d)) {
      const arr = d.items.slice();
      arr.items = arr;
      // ننقل كل الحقول المرافقة لا الترقيم فقط: كانت حقول مثل totalAmount
      // أو stats تضيع فيعرض الرأس مجموع الصفحة الظاهرة بدل مجموع الفترة.
      for (const [key, value] of Object.entries(d)) {
        if (key !== 'items') arr[key] = value;
      }
      res.data = arr;
    }
    return res;
  },
  (err) => {
    const status = err.response?.status;
    const path = err.config?.url || '';
    if (status === 401 && !path.includes('/auth/me') && !path.includes('/auth/login')) {
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    // الخادم رفض عملية نقدية/بيع لعدم وجود شفت مفتوح → نفتح نافذة فتح الشفت
    if (err.response?.data?.error?.code === 'NO_OPEN_SHIFT') {
      try { useShiftUI.getState().openModal('open'); } catch (_) { /* ignore */ }
    }
    if (status === 403) {
      // Surface a soft signal — the auth store / UI can show a toast.
      // eslint-disable-next-line no-console
      console.warn('Forbidden:', err.response?.data?.error?.message || 'permission denied');
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  return err?.response?.data?.error?.message || err?.message || 'خطأ غير معروف';
}

// يستخرج أخطاء الحقول من استجابة الخادم. الـ backend يُرجع
// `error.details = [{ path: ['username'], message: '...' }, ...]`.
// النتيجة: { username: 'الرسالة', email: 'الرسالة', ... }
export function fieldErrors(err) {
  const details = err?.response?.data?.error?.details;
  if (!Array.isArray(details)) return {};
  const out = {};
  for (const d of details) {
    if (!d) continue;
    const key = Array.isArray(d.path) ? d.path[0] : (typeof d.path === 'string' ? d.path : null);
    if (key && d.message && !out[key]) out[key] = d.message;
  }
  return out;
}
